import { useTheme } from '../contexts/ThemeContext';

const OPTIONS = [
  { value: 'light' as const, label: '\u2600\uFE0F Light' },
  { value: 'dark' as const, label: '\uD83C\uDF19 Dark' },
  { value: 'system' as const, label: '\u2699\uFE0F System' },
];

export default function ThemeToggle() {
  const { mode, setMode } = useTheme();

  return (
    <div className="malpedia-theme-toggle">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          className={`malpedia-theme-toggle-btn${mode === opt.value ? ' malpedia-theme-toggle-btn--active' : ''}`}
          onClick={() => setMode(opt.value)}
          aria-pressed={mode === opt.value}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
